import {browserHistory} from 'react-router';

/**
 * Navigate to the calls tab.
 */
export function navigateToCallsTab() {
  browserHistory.push({
    pathname: '/calls/my',
  });
}
